export default "/_next/static/media/tem3.77dd41f314939f57513ac4d54801ba13.jpg";